export default function addAccessory(
  {
    currentTarget,
    inputData,
    setInputDataToSend,
    treeStructureSettings,
    setTreeStructureSettings,
  },
) {
  const accessoryIRI = currentTarget.getAttribute('data-iri');
  const accessoryDescription = currentTarget.getAttribute('data-description');
  const associationIRI = currentTarget.getAttribute('data-value');
  setInputDataToSend('accessoriesFlat', [
    ...inputData.accessoriesFlat,
    {
      id: `${accessoryIRI}${associationIRI}`,
      parentId: treeStructureSettings.level !== 0
        ? treeStructureSettings.parentId[treeStructureSettings.level - 1] : null,
      product: accessoryIRI,
      productGroupAssociation: associationIRI,
      accessories: [],
    },
  ]);
  if (treeStructureSettings.level === 0) {
    setTreeStructureSettings(
      treeStructureSettings.level,
      { [treeStructureSettings.level]: `${accessoryIRI}${associationIRI}` },
      { [treeStructureSettings.level]: `${accessoryDescription}` },
    );
  } else {
    setTreeStructureSettings(treeStructureSettings.level,
      {
        ...treeStructureSettings.parentId,
        [treeStructureSettings.level]: `${accessoryIRI}${associationIRI}`,
      },
      {
        ...treeStructureSettings.parentName,
        [treeStructureSettings.level]: `${accessoryDescription}`,
      });
  }
}
